// import "babel-polyfill";
import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import { routes } from './router';
import { libConfig } from './lib-config';
import { messages } from './i18n';
import { language } from './util/language';
import { registerServiceWorker } from './registerServiceWorker';

require('@/assets/slick.css');

libConfig(Vue);
Vue.use(VueRouter);
// Vue.use(Vuex)

registerServiceWorker();

export const router = new VueRouter({
	mode: 'history',
	routes, // short for `routes: routes`
});


const i18n = new VueI18n({
	locale: language.getLanguage(),
	fallbackLocale: 'en',
	messages,
});

new Vue({
	el: '#app',
	// store: store,
	render: (h) => h(App),
	i18n,
	router,
}).$mount('#app');
